import { token } from '@atlaskit/tokens';
import { canMigrateToNewSpotlightPackage } from './common/canMigrateToNewSpotlightPackage.tsx';

export const PO_HEADLESS_PLACEMENT_ID = 'headless';
export const PO_HEADLESS_MESSAGE_TEMPLATE_ID = 'jpd-headless-spotlight';

export const OnboardingSpotlightFeatureIds = {
	START_WITH_TEMPLATE: 'start-with-template',
	CARD_COVERS: 'card-covers',
	TREE_VIEW_CREATE_MENU: 'tree-view.create-menu',
	CUSTOM_DATES_CUSTOMIZE: 'custom-dates.customize',
	GLOBAL_FIELDS_GO_TO_PROJECT: 'global-fields.go-to-project',
	JPD_NAV_VIEWS: 'jpd-nav-views',
	ROADMAP_VIEW: 'roadmap-view',
	ROADMAP_VIEW_COLUMN_CONFIG: 'roadmap-view.column-config',
	ROADMAP_VIEW_INITIAL_PROMPT: 'roadmap-view.initial-prompt',
	COLLECTIONS_CREATE_ROADMAP: 'collections.create-roadmap',
	UNIFIED_SHARE: 'unified-share',
} as const;
export type OnboardingSpotlightFeatureId =
	(typeof OnboardingSpotlightFeatureIds)[keyof typeof OnboardingSpotlightFeatureIds];

export type DefaultOnboardingSpotlightProps = {
	dialogWidth: number;
	targetRadius: number;
	targetBgColor: string;
	messageType: 'engagement' | 'marketing';
	isMigrated: boolean;
};

export const getDefaultOnboardingSpotlightProps = (): DefaultOnboardingSpotlightProps => ({
	dialogWidth: 275,
	targetRadius: 3,
	targetBgColor: token('elevation.surface'),
	messageType: 'engagement' as const,
	isMigrated: canMigrateToNewSpotlightPackage(),
});

// This export exists only to suppress filename validation for this constants file.
export const onboardingConstants = {};
